import React from 'react';
import styled from 'styled-components';

import Label from './Label';

const Container = styled.div`
  margin-bottom: 8px;
  position: relative;
`;

interface Props {
  id?: string;
  label?: string;
  children: React.ReactNode;
}

const ValueGroup = ({ id, children, label }: Props) => (
  <Container id={id}>
    {!!label && <Label>{label}</Label>}
    {children}
  </Container>
);

export default ValueGroup;
